'use client';

import { useEffect } from 'react';

import { reportError } from '@cntxt/shared/utilities/errors';

/**
 * Registers public/sw.js, which serves saved copies of pages and their JS/CSS
 * when a refresh finds no network. `updateViaCache: 'none'` makes the browser
 * check for a new sw.js on every load, so a deploy's worker is picked up at once.
 */
export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return;
    }

    navigator.serviceWorker
      .register('/sw.js', { scope: '/', updateViaCache: 'none' })
      .catch((error: unknown) => {
        reportError(error, 'Service worker registration failed');
      });
  }, []);

  return null;
}
